import {
  cleanTaskTypeName,
  getConditionName,
} from 'app/shared/components/loanManagement/loanActionsGroup/LoanActionTransformations.utils';
import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

const selectLoanActionsConditionsRaw = createSelector(
  getSystem,
  ({ loanActionsConditions }) => loanActionsConditions || {},
);

const selectLoanActionsConditionsValues = createSelector(
  selectLoanActionsConditionsRaw,
  loanActionsConditions => Object.values(loanActionsConditions),
);

export const selectLoanActionsConditions = createSelector(
  selectLoanActionsConditionsValues,
  loanActionsConditions =>
    loanActionsConditions.reduce((acc, condition) => {
      acc[condition.conditionId] = {
        ...condition,
        taskTypes: condition.taskTypes.map(({ taskTypeName, ...rest }) => ({
          ...rest,
          taskTypeName: cleanTaskTypeName(taskTypeName),
        })),
      };

      return acc;
    }, {}),
);

export const selectLoanActionsConditionsOptions = createSelector(
  selectLoanActionsConditionsValues,
  loanActionsConditions =>
    loanActionsConditions.map(condition => ({
      name: getConditionName(condition),
      value: condition.conditionId,
    })),
);
